import { render } from "./ControlsMenuComponent.vue?vue&type=template&id=1698a9fe&scoped=true&ts=true"
import script from "./ControlsMenuComponent.vue?vue&type=script&lang=ts"
export * from "./ControlsMenuComponent.vue?vue&type=script&lang=ts"

import "./ControlsMenuComponent.vue?vue&type=style&index=0&id=1698a9fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1698a9fe"]])

export default __exports__